import { render } from "./video_attachment.vue?vue&type=template&id=03a88bbe"
import script from "./video_attachment.js?vue&type=script&lang=js"
export * from "./video_attachment.js?vue&type=script&lang=js"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__